// extracted by mini-css-extract-plugin
export default {"workerActions":"Worker_workerActions__2Ua2s"};